export default [
  {
    id: 1,
    question: "قیمت",
    score: "",
  },
  {
    id: 2,
    question: "تنوع",
    score: "",
  },
  {
    id: 3,
    question: "ویزیت",
    score: "",
  },
  {
    id: 4,
    question: "کیفیت",
    score: "",
  },
  {
    id: 5,
    question: "طراحی",
    score: "",
  },
  {
    id: 6,
    question: "توزیع کالا",
    score: "",
  },
  {
    id: 7,
    question: "بسته بندی",
    score: "",
  },
  {
    id: 8,
    question: "حاشیه سود",
    score: "",
  },
  {
    id: 9,
    question: "طرح فروش",
    score: "",
  },
];
